import { useEffect, useState } from "react";
import { fetchDashboardStats } from "../../services/tripServices";

export default function Dashboard() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDashboardStats().then(data => {
            setStats(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch dashboard stats:", err);
        });
    }, []);

    return (
        <>
            <section className="cards">
                <div className="card">
                    <h3>Total Trips</h3>
                    <p className="metric">{loading ? "Loading..." : stats?.totalTrips}</p>
                </div>
                
                <div className="card">
                    <h3>Categories</h3>
                    <p className="metric">{loading ? "Loading..." : stats?.totalCategories}</p>
                </div>
                <div className="card">
                    <h3>Bookings</h3>
                    <p className="metric good">{loading ? "Loading..." : stats?.totalBookings}</p>
                </div>
            </section>
            <h2>Welcome to the Admin Panel</h2>
        </>
    )
}
